import { useLayoutEffect, useRef } from "react";

// Позиції живуть, поки відкритий застосунок (між переходами сторінками)
const positions = {};

/**
 * Запам'ятовує прокрутку сторінки при виході й відновлює при поверненні.
 *
 * ready — чи вміст уже на місці (наприклад, товари є в Redux). Відновлюємо лише
 * один раз і лише якщо вміст готовий одразу — інакше висота сторінки ще не та.
 */
const useScrollMemory = (key, ready) => {
  const restored = useRef(false);

  useLayoutEffect(() => {
    if (restored.current || !ready) return;
    restored.current = true;
    const y = positions[key];
    if (y) window.scrollTo(0, y);
  }, [key, ready]);

  // Layout-cleanup виконується до того, як React прибере сторінку з DOM,
  // тож scrollY ще не «обрізаний» коротшою наступною сторінкою
  useLayoutEffect(
    () => () => {
      positions[key] = window.scrollY;
    },
    [key]
  );
};

export default useScrollMemory;
